import { styled } from 'goober'

export const Wrapper = styled('div')`
  padding-inline: .8rem;
`
